var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1430,
    height: 1180,
    viewBox: "0 0 1430 1180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#circle_shadow_2_filter_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 580,
    r: 300,
    fill: "#07E2A0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#circle_shadow_2_filter_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 580,
    r: 200,
    fill: "#FFAA0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle_shadow_2_filter_1",
    x: 0,
    y: -20,
    width: 1200,
    height: 1200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circle_shadow_2_filter_2",
    x: 430,
    y: 80,
    width: 1000,
    height: 1000,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerOverlay);
export default __webpack_public_path__ + "static/media/banner-overlay.7e1ca933046f9bb53c0623fda89fb916.svg";
export { ForwardRef as ReactComponent };